import {
  getInstituteDetailsFromCampusId,
  setFilteredDashboardDetails,
  getYear,
} from '../../../../TPODashboard/action'
import { connect } from 'react-redux'
import StudentReportIndex from '../../StudentReports/index'
import {
  getDomainList,
  getDegreeList,
  getDepartmentList,
  getSpecializationList,
  exportCSV,
  customerReportDataList
} from '../../../action'
import { getJobCategory } from '../../../../JobRoles/NewJobRole/actions'

const mapStateToProps = state => ({})

const mapDispatchToProps = {
  getYear,
  getDomainList,
  getInstituteDetailsFromCampusId,
  getDegreeList,
  setFilteredDashboardDetails,
  getDepartmentList,
  getSpecializationList,
  exportCSV,
  getJobCategory,
  customerReportDataList
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentReportIndex)
